import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { getPropertyName } from '../../helpers/utils'
import BaseElement from './BaseElement'

const ParagraphMutator = ({ definition, value, itemKey, buttons, handleUpdate }) => {
  const [controlledValue, setValue] = useState(value)
  const title = useMemo(() => getPropertyName(definition?.title, itemKey), [definition, itemKey])

  const handleChange = useCallback((text) => {
    const newValue = text
    if (value !== newValue) {
      setValue(newValue)
      handleUpdate(newValue)
    }    
  }, [value, handleUpdate])

  useEffect(() => {
    setValue(value)
  }, [value])

  return (
    <BaseElement error={!definition}>
      <header-area>
        <span>{title}</span>
        <div>
          {buttons}
        </div>
      </header-area>
      <textarea 
        value={controlledValue}
        onChange={handleChange}
      />
    </BaseElement>
  )
}

export default ParagraphMutator